import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import React from 'react'
import { DBTables } from '../../types/supabaseSugarTypes'

import { GithubInviteForm } from '@/components/GithubInviteForm'
import { CardDescription } from '@/components/ui/card'
import { LicenseAgreement } from '@/components/LicenseAgreement'
import { configureSubDialogClassName } from '@/components/configureSubDialogClassName'

type Subscription = DBTables['subscriptions']['Row']

// License last updated date - must match the date in license.mdx
const LICENSE_LAST_UPDATED = new Date('2025-11-30')

export const EditSubscriptionDialog = ({
  subscription,
  open,
  onOpenChange,
}: {
  subscription: Subscription
  open: boolean
  onOpenChange: (open: boolean) => void
}) => {
  const [container, setContainer] = React.useState<HTMLDivElement | null>(null)
  const [hasAgreedToLicense, setHasAgreedToLicense] = React.useState<boolean>(false)

  const needsToAgreeToLicenseAgreement =
    !hasAgreedToLicense &&
    (subscription.license_agreement_date === null ||
      new Date(subscription.license_agreement_date) < LICENSE_LAST_UPDATED)

  const handleLicenseAgreed = () => {
    setHasAgreedToLicense(true)
  }

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent container={container} className={configureSubDialogClassName}>
          {needsToAgreeToLicenseAgreement ? (
            <LicenseAgreement userId={subscription.auth_user_id} onAgreed={handleLicenseAgreed} />
          ) : (
            <>
              <DialogHeader className={'pr-10'}>
                <DialogTitle>GitHub repository & npm package access invites</DialogTitle>
                <CardDescription>
                  Invite up to {subscription.seats} GitHub users who get access
                </CardDescription>
              </DialogHeader>
              <GithubInviteForm subscription={subscription} />
            </>
          )}
        </DialogContent>
      </Dialog>
      <div ref={setContainer} />
    </>
  )
}
